import { METHODS, PROPS_ACCESS } from './consts';
var globalContext;
export function getGlobalAccessor() {
    [getGlobalThis, getGlobal, getSelf, getWindow].forEach(function (globalAccessFunc) {
        try {
            if (!globalContext) {
                globalContext = globalAccessFunc();
            }
        }
        catch (e) {
            // Lint this mofo
        }
    });
    return globalContext;
}
function getWindow() {
    return window;
}
function getSelf() {
    return self;
}
function getGlobal() {
    return global;
}
function getGlobalThis() {
    return globalThis;
}
export function getConsentPolicyManager(env) {
    if (env === void 0) { env = undefined; }
    if (env) {
        globalContext = env;
    }
    if (!globalContext && !env) {
        globalContext = getGlobalAccessor();
    }
    var consentPolicyManager;
    try {
        if (typeof globalContext.commonConfig === 'object' &&
            globalContext.commonConfig.consentPolicy) {
            consentPolicyManager = wrapConsentPolicy(globalContext.commonConfig, PROPS_ACCESS);
        }
        if (!consentPolicyManager &&
            typeof globalContext.consentPolicyManager === 'object') {
            consentPolicyManager = wrapConsentPolicy(globalContext.consentPolicyManager, METHODS);
        }
        if (!consentPolicyManager &&
            typeof globalContext.Wix === 'object' &&
            typeof globalContext.Wix.Utils === 'object' &&
            typeof globalContext.Wix.Utils.getCurrentConsentPolicy === 'function') {
            consentPolicyManager = wrapConsentPolicy(globalContext.Wix.Utils, METHODS);
        }
    }
    catch (e) {
        // Lint this if you can
    }
    return consentPolicyManager;
}
function wrapConsentPolicy(accessor, conf) {
    return {
        getCurrentConsentPolicy: function () {
            var extractor = accessor[conf.policy];
            return conf.isMethod ? extractor() : extractor;
        },
        _getConsentPolicyHeader: function () {
            var extractor = accessor[conf.header];
            return conf.isMethod ? extractor() : extractor;
        },
        deleteReference: !conf.isMethod,
    };
}
//# sourceMappingURL=consent-policy-accessor.js.map